import React from 'react';

/**
 * Pre-launch testing banner.
 * Reservo is not yet authorised as a Booking Service Provider in NSW under the
 * Point to Point Transport (Taxis and Hire Vehicles) Act 2016. This banner must
 * remain visible until authorisation is granted and the legal documents have
 * been reviewed by an Australian-qualified legal practitioner.
 *
 * Props:
 *   variant: 'full' (login page) | 'inline' (booking wizard, in-app)
 */
export default function PreLaunchBanner({ variant = 'inline' }) {
  const isFullWidth = variant === 'full';

  const containerStyle = {
    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
    border: '2px solid #f59e0b',
    borderRadius: isFullWidth ? 0 : 12,
    padding: isFullWidth ? '14px 24px' : '16px 20px',
    margin: isFullWidth ? '0 0 24px 0' : '0 0 20px 0',
    color: '#78350f',
    fontSize: '0.92rem',
    lineHeight: 1.5,
    boxShadow: isFullWidth ? '0 2px 8px rgba(245, 158, 11, 0.15)' : 'none',
  };

  const headerStyle = {
    fontWeight: 800,
    fontSize: '1rem',
    marginBottom: 4,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    letterSpacing: 0.3,
  };

  return (
    <div role="alert" aria-live="polite" style={containerStyle}>
      <div style={headerStyle}>
        <span aria-hidden="true">!</span>
        <span>PRE-LAUNCH TESTING ONLY</span>
      </div>
      <div>
        Reservo is not yet authorised as a Booking Service Provider in NSW.{' '}
        <strong>Do not book real trips.</strong> Real money is not charged.
        Any data entered may be deleted without notice during testing.
      </div>
    </div>
  );
}
